import React from "react";
import "./SkeletonLoader.css";

const SkeletonLoader = ({
  type = "product",
  count = 8,
  gridColumns = 4,
  className = "",
}) => {
  const skeletonItems = Array(count).fill(null);

  const renderProductSkeleton = () => (
    <div className="skeleton-product">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-price"></div>
        <div className="skeleton-buttons">
          <div className="skeleton-button"></div>
          <div className="skeleton-button-small"></div>
        </div>
      </div>
    </div>
  );

  const renderContactSkeleton = () => (
    <div className="skeleton-contact">
      <div className="skeleton-cards">
        <div className="skeleton-card">
          <div className="skeleton-icon"></div>
          <div className="skeleton-text"></div>
        </div>
        <div className="skeleton-card">
          <div className="skeleton-icon"></div>
          <div className="skeleton-text"></div>
        </div>
      </div>
      <div className="skeleton-form">
        <div className="skeleton-input"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-textarea"></div>
        <div className="skeleton-submit"></div>
      </div>
    </div>
  );

  if (type === "contact") {
    return (
      <div className={`skeleton-loader ${className}`}>
        {renderContactSkeleton()}
      </div>
    );
  }

  return (
    <div
      className={`skeleton-loader skeleton-grid ${className}`}
      style={{ gridTemplateColumns: `repeat(${gridColumns}, 1fr)` }}
    >
      {skeletonItems.map((_, index) => (
        <div key={index}>{renderProductSkeleton()}</div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
